import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md).
const makeStyles = colors =>
  StyleSheet.create({
    bar: {
      backgroundColor: colors.backgroundMuted,
      borderTopWidth: 1,
      borderTopColor: colors.borderMuted,
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    doneButton: {
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
  });

export default makeStyles;
